import React, { useState, useEffect } from "react";
import SignupSelect from "./SignupSelect";
import SignUp from "./SignUp";

function SignupRouter() {
  const [isBuyer, setIsBuyer] = useState(false);

  useEffect(() => {
    const isStandalone =
      window.matchMedia("(display-mode: standalone)").matches ||
      window.navigator.standalone === true;

    if (isStandalone) {
      setIsBuyer(true);
    }
  }, []);

  return isBuyer ? (
    <SignUp />
  ) : (
    <SignupSelect onBuyerSelect={() => setIsBuyer(true)} />
  );
}

export default SignupRouter;
